import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadNextStep, type NextStepResponse } from "@/services/nextStep";

/**
 * Subscribe to the server-decided next best action.
 * Fetches once per route (module-level cache dedupes across consumers)
 * and refetches on route change. Returns null while loading, when
 * disabled, or when the fetch fails — callers hide their surfaces on null.
 */
export function useServerNextStep(enabled: boolean): NextStepResponse | null {
  const location = useLocation();
  const [nextStep, setNextStep] = useState<NextStepResponse | null>(null);

  useEffect(() => {
    if (!enabled) {
      setNextStep(null);
      return;
    }
    let cancelled = false;
    loadNextStep(location.pathname).then(result => {
      if (!cancelled) setNextStep(result);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled, location.pathname]);

  return nextStep;
}
